import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';

export default function Settings() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('settings.title')}</h1>

      <div className="space-y-6">
        {/* Profile Section */}
        <Card>
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('settings.profile')}</h2>
          <div className="space-y-3">
            <div>
              <p className="text-sm text-gray-600">{t('auth.email')}</p>
              <p className="text-gray-900 font-medium">{user?.email}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">{t('auth.fullName')}</p>
              <p className="text-gray-900 font-medium">{user?.full_name}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">{t('common.role')}</p>
              <p className="text-gray-900 font-medium capitalize">{user?.role}</p>
            </div>
          </div>
        </Card>

        {/* Language Section */}
        <Card>
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('settings.language')}</h2>
          <div className="flex gap-3">
            <Button
              variant={i18n.language === 'fr' ? 'primary' : 'secondary'}
              size="sm"
              onClick={() => changeLanguage('fr')}
            >
              Français
            </Button>
            <Button
              variant={i18n.language === 'en' ? 'primary' : 'secondary'}
              size="sm"
              onClick={() => changeLanguage('en')}
            >
              English
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
